var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f50ffbaa6577b3deea201919dbeb738614f7fa48"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["marketplace@fieldfolio"]={id:"f50ffbaa6577b3deea201919dbeb738614f7fa48"};
      